

var _squid = require('squid');

require('./directive');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCepRoute', function () {
    return _squid.$ComponentRoute.extend('AddCepRoute', {
        name: 'addCep',
        directive: 'xo-add-cep',
        titleContent: 'addBillingAddress.title',
        loginRequired: true,
        children: []
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/addCep/route.js
// module id = ../node_modules/xo-wallet-components/src/add-card/addCep/route.js
// module chunks = 0